import React from 'react';

function Topbar() {
    return (
        <div className="top-bar d-none d-md-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-9 col-12">
                        <a href="tel:0724273258" className="top-left">
                            Telefon: <span>0724.273.258</span>
                        </a>
                        <a href="mailto:office@reparatiiasfalt.ro" className="top-left">
                            Email: office@reparatiiasfalt.ro
                        </a>
                    </div>
                    <div className="col-lg-3 col-12 d-none d-lg-block text-lg-right">
                        <span className="top-left">Luni - Sâmbătă: 8:00 - 18:00</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Topbar;
